import { legacy_createStore as createReduxStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";
import { persistStore, persistReducer } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createReduxStore(
  persistedReducer,
  composeWithDevTools()
);

export const persistor = persistStore(store);

export const configureStore = () => ({ store, persistor });
